import * as amplitudeSdk from '@amplitude/analytics-browser';
import { getConfig } from 'config';
import AnalyticsServiceDevImpl from './AnalyticsServiceDevImpl';
import AnalyticsServiceImpl from './AnalyticsServiceImpl';
import { IAnalyticsService } from './AnalyticsService';

// Starts as the console-only decoy; upgraded to the real service if an API key is present.
let analyticsService: IAnalyticsService = new AnalyticsServiceDevImpl();

export const getAnalyticsService = (): IAnalyticsService => analyticsService;

const initAnalytics = async (): Promise<void> => {
  const apiKey = getConfig('AMPLITUDE_API_KEY');

  if (apiKey) {
    await amplitudeSdk.init(apiKey, { autocapture: false, serverZone: 'EU' }).promise;
    analyticsService = new AnalyticsServiceImpl();
  }
  // No API key → keep the console-logging dev implementation
};

export default initAnalytics;
